import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IxNgBusyFormService, IxServiceBaseUtil } from 'ix-ng-components';
import { IxKeycloakHttp, IxNgHttpService } from 'ix-ng-http';
import { IxNgRoutingService } from 'ix-ng-routing';
import { IxNgErrorHandlingService } from 'ix-ng-forms';
import { Maybe } from 'ix-ng-static-utils';
import { StringDTO } from '../../dto/stringDTO.model';

@Component({
  selector: 'lib-page-not-found',
  templateUrl: './page-not-found.component.html',
})
export class PageNotFoundComponent implements OnInit {
  public text404: string | undefined | null;
  private router = inject(Router);
  private ixServiceUtil = inject(IxServiceBaseUtil);

  constructor() {
    const ixKeycloakHttp = inject(IxKeycloakHttp);
    const ixNgRoutingService = inject(IxNgRoutingService);
    const ixNgErrorHandlingService = inject(IxNgErrorHandlingService);
    const ixNgHttpService = inject(IxNgHttpService);
    const ixNgBusyFormService = inject(IxNgBusyFormService);

    this.ixServiceUtil = new IxServiceBaseUtil(
      ixKeycloakHttp,
      ixNgRoutingService,
      ixNgErrorHandlingService,
      ixNgHttpService,
      ixNgBusyFormService,
    );

    this.ixServiceUtil.serviceUrl = `/vpoglednik`;
  }

  goHome() {
    this.router.navigate(['/vpoglednik']);
  }

  ngOnInit() {
    this.read404Message();
  }

  read404Message() {
    this.ixServiceUtil.safeCall(
      () => this.ixServiceUtil.get('read404Message'),
      (result: Maybe<StringDTO>) => {
        if (result) {
          this.text404 = result.value;
        }
      },
    );
  }
}
